import React from 'react';
import PropTypes from 'prop-types';

const UiDismissMediumPath = ({ fill }) => {
  return (
    <path
      fill={fill}
      d="M18.673 6.74a.562.562 0 0 0 0-.795l-.618-.618a.562.562 0 0 0-.796 0L12 10.586l-5.26-5.26a.562.562 0 0 0-.795 0l-.618.62a.562.562 0 0 0 0 .795L10.586 12l-5.26 5.26a.562.562 0 0 0 0 .795l.62.618c.22.22.575.22.795 0L12 13.414l5.26 5.26c.219.219.575.219.795 0l.618-.62a.562.562 0 0 0 0-.795L13.414 12l5.26-5.26z"
    />
  );
};

UiDismissMediumPath.propTypes = {
  fill: PropTypes.string,
};

export default UiDismissMediumPath;



// WEBPACK FOOTER //
// ./src/icon/svgs/ui-controls/ui-dismiss-medium.jsx